import classNames from 'classnames'
import React from 'react'

import { IBaseProps } from 'browser/components/atomic-elements/atoms/base-props'
import { HelpBlock } from 'browser/components/atomic-elements/atoms/help-block/help-block'
import { renderEventTimestamp } from '../util'
import { EventChanges } from '../workflow-events/event-changes'
import { EventChangeSetList } from '../document-events/event-change-set-list'

interface IAIBlockUsageItem extends IBaseProps {
  entity: any
  item: any
  isFirst: boolean
  isLast: boolean
  showEdgeActivity?: boolean
}

export class AiBlockUsageItem extends React.Component<IAIBlockUsageItem, any> {
  public render() {
    const { className, item, entity, isFirst, showEdgeActivity } = this.props
    const { result, creationDate, aiBlock, tokenUsage } = item

    const changeSet = result?.changeSet || {}

    return (
      <div className={classNames('c-timelineEvent', className)} key={item.uniqueId}>
        <div
          className={classNames('c-timelineEvent-line', className, {
            'c-timelineEvent-line--topCutOff': isFirst,
          })}
        />
        <div className="c-timelineEvent-dot" />
        <div className="c-timelineEvent-contentContainer">
          <div className="c-timelineEvent-body">
            <HelpBlock>
              <span className="b">{aiBlock.displayName ?? 'AI Block'}</span> updated on{' '}
              {renderEventTimestamp(creationDate)}:<br />
              <span className="b">Action :</span> {result.action}
              <br />
              {tokenUsage && (
                <>
                  <span className="b">Total Token:</span> {tokenUsage.total}
                  <br />
                </>
              )}
              <EventChanges>
                <EventChangeSetList
                  entity={entity}
                  changeSet={changeSet}
                  showEdgeActivity={showEdgeActivity}
                  fallbackToRawPath={true}
                />
              </EventChanges>
            </HelpBlock>
          </div>
        </div>
      </div>
    )
  }
}
